var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "deal-notes" }, [
    _vm.loading
      ? _c("div", { staticClass: "notes-loading" }, [_vm._m(0)])
      : _vm.notes.length === 0
      ? _c("div", { staticClass: "no-notes" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("note")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.noNotesAdded")))]),
        ])
      : _c(
          "div",
          { staticClass: "notes-list" },
          _vm._l(_vm.notes, function (note) {
            return _c("div", { key: note.id, staticClass: "note-item" }, [
              _c("div", { staticClass: "note-header" }, [
                _c("div", { staticClass: "note-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("description"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(note.Note_Title) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "note-meta" }, [
                  _c("span", { staticClass: "note-owner" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$_.get(note, "Owner.name", "")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "note-date" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("schedule"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.formatDate(note.Created_Time)) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "note-content" }, [
                _vm._v(_vm._s(note.Note_Content)),
              ]),
              _vm._v(" "),
              _vm.hasAttachments(note)
                ? _c("div", { staticClass: "note-attachments" }, [
                    _c("div", { staticClass: "attachments-title" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("attach_file"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.attachments")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "attachments-list" },
                      _vm._l(
                        _vm.$_.get(note, "$attachments", []),
                        function (attachment) {
                          return _c(
                            "div",
                            {
                              key: attachment.id,
                              staticClass: "attachment-item",
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("insert_drive_file"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(attachment.File_Name)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "file-size" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.formatFileSize(attachment.Size)
                                    ) +
                                    ")"
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ])
          }),
          0
        ),
    _vm._v(" "),
    _vm.hasZohoChannel
      ? _c("div", { staticClass: "add-note-form" }, [
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.addNewNote")))]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newNote.title,
                  expression: "newNote.title",
                },
              ],
              staticClass: "note-input",
              attrs: { type: "text", placeholder: _vm.$t("message.noteTitle") },
              domProps: { value: _vm.newNote.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newNote, "title", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newNote.content,
                  expression: "newNote.content",
                },
              ],
              staticClass: "note-textarea",
              attrs: { placeholder: _vm.$t("message.noteContent") },
              domProps: { value: _vm.newNote.content },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newNote, "content", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "save-button",
              attrs: { disabled: _vm.saving },
              on: { click: _vm.saveNote },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.saving
                      ? _vm.$t("message.savingg")
                      : _vm.$t("message.save")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ])
      : _c("div", { staticClass: "zoho-connect-message" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.connectToZoho")) +
              "\n        "
          ),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("connect-zoho")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("message.connectZoho")))]
          ),
          _vm._v(".\n    "),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loading-skeleton" }, [
      _c("div", { staticClass: "skeleton-item" }, [
        _c("div", { staticClass: "skeleton-header" }, [
          _c("div", { staticClass: "skeleton-title" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-meta" }, [
            _c("div", { staticClass: "skeleton-date" }),
            _vm._v(" "),
            _c("div", { staticClass: "skeleton-owner" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-content" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-item" }, [
        _c("div", { staticClass: "skeleton-header" }, [
          _c("div", { staticClass: "skeleton-title" }),
          _vm._v(" "),
          _c("div", { staticClass: "skeleton-meta" }, [
            _c("div", { staticClass: "skeleton-date" }),
            _vm._v(" "),
            _c("div", { staticClass: "skeleton-owner" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-content" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }